// extracted by mini-css-extract-plugin
module.exports = {"badgeBlock":"Badge_badgeBlock__H8fs2","badge":"Badge_badge__2st4I","blueBadge":"Badge_blueBadge__J0rnb"};